/**
 * Constants definition.
 *
 * @type {{NEW_CONSTRUCTION: string, PERMUTE: string, HOUSE_PURCHASE: string, DEATH: string, DATA_UPDATE: string}}
 */
const RESIDENTIAL_REQ_REASON = {
  NEW_CONSTRUCTION: 'NEW_CONSTRUCTION',
  PERMUTE: 'PERMUTE',
  HOUSE_PURCHASE: 'HOUSE_PURCHASE',
  DEATH: 'DEATH',
  DATA_UPDATE: 'DATA_UPDATE',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const RESIDENTIAL_REQ_REASON_ENUM = Object.keys(RESIDENTIAL_REQ_REASON);

const NEW_CONSTRUCTION = RESIDENTIAL_REQ_REASON_ENUM[0];
const PERMUTE = RESIDENTIAL_REQ_REASON_ENUM[1];
const HOUSE_PURCHASE = RESIDENTIAL_REQ_REASON_ENUM[2];
const DEATH = RESIDENTIAL_REQ_REASON_ENUM[3];
const DATA_UPDATE = RESIDENTIAL_REQ_REASON_ENUM[4];

export {
  RESIDENTIAL_REQ_REASON,
  NEW_CONSTRUCTION,
  PERMUTE,
  HOUSE_PURCHASE,
  DEATH,
  DATA_UPDATE,
  RESIDENTIAL_REQ_REASON_ENUM,
};
